module.exports = __webpack_public_path__ + "media/images/bg_4-d8dee9ca4282fa8b80b527a9ee4ab1d0.jpg";